import TraitSalesContext from "contexts/TraitSalesContext";
import { useContext } from "react";

const useTraitSales = () => useContext(TraitSalesContext);

export default useTraitSales;
